module.exports = {
    title: '合約量化機器人，安全便捷高效讓交易更安心。',
    ul_li1: '聯係客服',
    ul_li2: '幫助中心',
    ul_li2_phone: '幫助中心',
    ul_li3: 'OKX注冊地址',
    ul_li4: '服務條款',
    ul_li4_phone: '服務條款',
    download_app: '下載App',
    send: '發送',
    feedback: '意見反饋',
    select_question_type: '選擇問題類型',
    problem_description: '問題描述',
    please_enter_content: '請輸入內容',
    add_photo: '添加照片',
    submit: '提交',
    scan_qr_code: '掃描二維碼下載',
    ios_coming_soon: 'IOS即將上線',
    complain: '投訴',
    suggestion: '建議',
    fault: '故障',
    other: '其他',
    content_yet: '暫無內容',
    fee_exemption: '免燃料費政策即將到期',
    live_broadcast:'UPLUS直播'

}
